import React from 'react';
import ReactDOM from 'react-dom';
import Builder from './Containers/Builder/Builder';

import '../src/index.css'

ReactDOM.render(<Builder />, document.getElementById('root'));

